import(/* webpackMode: "eager" */ "/vercel/path0/src/app/dewihall/proposals/[proposalKey]/page.tsx")